<template>
  <layout
    :titlePage="'Configurando seu site'"
    :route="{ path: '/onboarding/passo-4' }"
  >
    <div
      class="columns columns--full is-vcentered onboarding-create-site__error"
    >
      <div class="column has-text-centered onboarding-create-site__description">
        <transition appear name="slide-fade" mode="in-out">
          <div class="onboarding-create-site__description--width-80">
            <p></p>
            <h1 class="onboarding-create-site__title has-text-weight-bold">
              🤯<br />
              Oops, parece que houve um imprevisto com a montagem do seu site
            </h1>
            <p class="onboarding-create-site__error--subtitle">
              Você pode tentar novamente para manter as configurações ou
              personalizar seu site mais tarde.
            </p>
            <div>
              <router-link
                :to="{ path: '/onboarding/passo-1' }"
                class="button is-big is-primary"
                >Tentar novamente
              </router-link>
              <p class="onboarding-create-site__jump-all-steps">
                <a
                  :href="redirectUrl"
                  class="onboarding-create-site__jump-all-steps--link"
                  >Seguir com site padrão
                </a>
              </p>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  components: {
    layout,
  },

  metaInfo: {
    title: 'Erro na configuração do site',
  },

  computed: {
    redirectUrl() {
      const logonToken = this.$store.state.app.logonToken
      // eslint-disable-next-line prettier/prettier
      return `${API_LEGACY_URL}/${logonToken.token_payload.wed_id}?skip_onboarding=1`
    },
  },
}
</script>
